import React from "react";
import ReactDOM from "react-dom";
import { Box, Paper, TextField, Typography } from '@mui/material';


export interface RootProps {
  columns?: string[];
  cards?: {status: any}[];
  onCardMove?: (card: any, status: any) => void
}

 const Root : React.FC<RootProps> = (props) => {

  return <div style={{
    display: 'flex',
    flexDirection: 'column',
    padding: '8px'
  }}>
      <Typography>Kanban</Typography>
      <Box>
        {props.columns?.map((column) => (
          <Box>
            {props.cards?.filter((card) => card.status == column)?.map((card) => (
              <Box>
                Card
              </Box>
            ))}
          </Box>
        ))}
      </Box>
    </div>;
}

export default Root;